import { useMemo } from 'react';
import { useBindViewer } from '../../hooks/useBindViewer';
import { canComment } from '../can-comment';
import { canDeleteComment } from '../can-delete-comment';
import { canEditComment } from '../can-edit-comment';
import { canCommentSocialEvent, canDeleteSocialEventComment } from '../permissions';

export const useCommentPermissions = () => {
  const bindViewer = useBindViewer();

  return useMemo(
    () => ({
      canComment: bindViewer(canComment),
      canCommentSocialEvent: bindViewer(canCommentSocialEvent),
      canDeleteComment: bindViewer(canDeleteComment),
      canDeleteSocialEventComment: bindViewer(canDeleteSocialEventComment),
      canEditComment: bindViewer(canEditComment),
    }),
    [bindViewer],
  );
};
